module.exports = __webpack_public_path__ + "img/bbb3.b11eeb27.gif";